var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyShipmentBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 227,
    viewBox: "0 0 305 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.627 39.7942C69.7389 39.7942 35.9638 18.6351 12.8487 39.7942C-12.9624 63.4214 19.1942 80.689 19.1942 119.109C19.1942 153.113 -18.2988 191.483 12.8488 209.594C43.9964 227.705 62.0486 191.009 107.167 191.009C148.587 191.009 146.092 208.685 190.007 220.558C261.868 239.988 304.785 212.093 304.785 181.699C304.785 151.305 252.256 133.987 277.837 92.5927C312.811 35.9985 289.005 0.256338 244.498 0.256348C195.707 0.256358 185.515 39.7942 127.627 39.7942Z",
    fill: "#DEE9FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyShipmentBg);
export default __webpack_public_path__ + "static/media/empty-shipment-bg.dcc0bd9d8d6f159fb4081223e92ec8d7.svg";
export { ForwardRef as ReactComponent };